import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    // clinics: typeof window !== 'undefined' && (localStorage.getItem('clinicsList') ? (JSON.parse(localStorage.getItem('clinicsList'))) : []),
    clinics: [],
    // selectedClinic: typeof window !== 'undefined' && JSON.parse(localStorage.getItem('clinic')) || {},
    selectedClinic: { clinicId: null, clinicName: "" },
    loading: false,
    error: false,
    clinicTabsValue: 0,
}

const clinicSlice = createSlice({
    name: "clinics",
    initialState,
    reducers: {
        fetchClinicsRequest: (state, action) => {
            state.loading = true
        },
        fetchClinicsSuccess: (state, action) => {
            state.loading = false
            state.clinics = action.payload
            // localStorage.setItem('clinicsList', JSON.stringify(action.payload || []))
        },
        fetchClinicsFailure: (state, action) => {
            state.loading = false
            state.error = action.payload
            state.clinics = []
            localStorage.setItem("clinicsList", [])
        },
        updateSelectedClinic: (state, action) => {
            // localStorage.setItem('clinic', JSON.stringify(action.payload))
            state.selectedClinic = action.payload
        },
        updateClinicsTabValue: (state, action) => {
            state.clinicTabsValue = action.payload
        },
    },
})

export const {
    fetchClinicsFailure,
    fetchClinicsRequest,
    fetchClinicsSuccess,
    updateSelectedClinic,
    updateClinicsTabValue,
} = clinicSlice.actions

export default clinicSlice.reducer
